import { createSlice } from "@reduxjs/toolkit";
import { stateEnum } from "../constants/enum";

const { shape } = stateEnum;

let initialState = {
    detailParams: {},
    isNewEntry: false
};


const shapeSlice = createSlice({
    name: shape,
    initialState,
    reducers: {
        setNewEntryMode: (state, action) => {
            state.isNewEntry = action.payload;
        },
        setDetailParams: (state, action) => {
            state.detailParams = action.payload
          },
        resetDetail: (state) => {
            state.detailParams = {};
            state.isNewEntry = true;
        },
    },
    
});


export const { setNewEntryMode,setDetailParams, resetDetail } = shapeSlice.actions;
export default shapeSlice.reducer;
